export default ( func, timeout = 300 ) => {
	let timer: NodeJS.Timeout;

	return ( ...args: unknown[] ) => {

		clearTimeout( timer );

		timer = setTimeout(
			() => { func.apply( this as unknown, args ); },
			timeout,
		);
	};
};
